module.exports = __webpack_public_path__ + "img/augmentation.32bc7610.jpg";